export default __webpack_public_path__ + "static/media/fr.a2504ba6.svg";